const GoIaqsMarker = ({ color = '#6285C3', letter, score, ...svgProps }) => (
  // Selected score pill from the Figma score bar. The colored top capsule shows
  // the number; the black lower capsule shows the category letter.
  <svg
    viewBox='0 0 21.3155 57.0057'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...svgProps}
  >
    <path
      fill='#1D1D1B'
      d='M10.6578 0C4.7843 0 0 4.769 0 10.6363V46.3694C0 52.231 4.7786 57.0057 10.6578 57.0057C16.5369 57.0057 21.3155 52.2367 21.3155 46.3694V10.6363C21.3155 4.7747 16.5369 0 10.6578 0Z'
    />
    <rect
      x='0.8008'
      y='0.7998'
      width='19.8'
      height='39'
      rx='9.75'
      fill={color}
    />
    {score != null && (
      <text
        x='10.6578'
        y='21.5'
        textAnchor='middle'
        dominantBaseline='central'
        fill='#1D1D1B'
        fontFamily='Roboto, Arial, sans-serif'
        fontSize='11'
        fontWeight='700'
      >
        {score}
      </text>
    )}
    {letter && (
      <text
        x='10.6578'
        y='47.5'
        textAnchor='middle'
        dominantBaseline='central'
        fill='white'
        fontFamily='Roboto, Arial, sans-serif'
        fontSize='11'
        fontWeight='700'
      >
        {letter}
      </text>
    )}
  </svg>
)

export default GoIaqsMarker
